const measurementSystemCodes = [
  "BIS", // British Imperial System
  "SI", // International System of Units
  "USCS", // United States Customary System
] as const

export type MeasurementSystemCode = (typeof measurementSystemCodes)[number]

export const supportedMeasurementSystemCodes = measurementSystemCodes.filter(
  (msCode) => msCode !== "BIS"
)

export type SupportedMeasurementSystemCode =
  (typeof supportedMeasurementSystemCodes)[number]
